import { Box, Button, Flex, Grid, GridItem, Input, Textarea } from '@chakra-ui/react'
import { yupResolver } from '@hookform/resolvers/yup'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { useRef, useState } from 'react'
import * as Yup from 'yup'

import { MdWork } from 'react-icons/md'

import DefaultLayout from '../../../../layouts/DefaultLayout'

// Services
import { mailTemplateServices } from '../../../../services/common/mailTemplates/index'

// Components
import CustomInputForm from '../../../../components/customFormElements/CustomInputForm'

import GeneralCard from '../../../../components/cards/generalCard/GeneralCard'
import NavCard from '../../../../components/cards/navCard/NavigateCard'
import ProjectSelect from '../../../../components/selects/ProjectSelect'
import LanguageSelect from '../../../../components/selects/LanguageSelect'
import MailTypeSelect from '../../../../components/selects/MailTypeSelect'
import { Editor } from '@tinymce/tinymce-react'

type MailTemplateFormData = {
  type: string
  name: string
  content: string
  languageCode: string
  fromMail: string
  subject: string
  projectId: string
}

const MailTemplateCreate = () => {
  const [selectedMailType, setSelectedMailType] = useState<any | null>(null)
  const [selectedLanguage, setSelectedLanguage] = useState<any | null>(null)
  const [selectedProject, setSelectedProject] = useState<any | null>(null)
  const [editorData, setEditorData] = useState<any>()

  const navigate = useNavigate()

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    fromMail: Yup.string().required('From Mail is required'),
    subject: Yup.string().required('Subject is required'),
  })
  const handleEditorChange = (content: string, editor: any) => {
    setEditorData(content)
  }

  const handleOnSubmit = () => {
    handleSubmit(onSubmit)()
  }

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<MailTemplateFormData>({
    resolver: yupResolver(validationSchema),
  })

  const onSubmit = (data: MailTemplateFormData) => {
    if (!selectedMailType) {
      toast('Mail Type is required')
      return
    }

    if (!selectedLanguage) {
      toast('Language is required')
      return
    }

    if (!selectedProject) {
      toast('Project is required')
      return
    }

    if (!editorData) {
      toast('Content is required')
      return
    }

    data.type = selectedMailType
    data.languageCode = selectedLanguage.code
    data.projectId = selectedProject.id
    data.content = editorData

    mailTemplateServices.create(data).finally(() => {
      navigate('/mail-template')
    })
  }

  return (
    <DefaultLayout>
      <NavCard icon={MdWork} pageName='Mail Template' />
      <form onSubmit={handleSubmit(onSubmit)}>
        <GeneralCard title='Add Mail Template'>
          <Grid templateRows='repeat(2, 1fr)' templateColumns='repeat(6, 1fr)' gap={2} margin={'20px'}>
            <CustomInputForm
              title='Project'
              children={
                <ProjectSelect selectedProject={selectedProject} setSelectedProject={setSelectedProject} id='' />
              }
            />
            <CustomInputForm
              title='Type'
              children={
                <MailTypeSelect selectedMailType={selectedMailType} setSelectedMailType={setSelectedMailType} type='' />
              }
            />
            <CustomInputForm
              title='Language'
              children={
                <LanguageSelect selectedLanguage={selectedLanguage} setSelectedLanguage={setSelectedLanguage} code='' />
              }
            />
            <CustomInputForm
              title='Name'
              error={errors.name}
              children={<Input type='text' id='name' {...register('name')} />}
            />
            <CustomInputForm
              title='From Mail'
              error={errors.fromMail}
              children={<Input type='text' id='fromMail' {...register('fromMail')} />}
            />
            <CustomInputForm
              title='Subject'
              error={errors.subject}
              children={<Input type='text' id='subject' {...register('subject')} />}
            />
            <GridItem
              colSpan={6}
              children={
                <Editor
                  apiKey='uhsd8cs3nsvcr8l0t1nwi8ix65n1p3mb21708bl77jr8wh9d'
                  init={{
                    skin: 'snow',
                    icons: 'thin',
                    height: 900,
                    menubar: true,
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen textcolor ',
                      'insertdatetime media table paste code help wordcount',
                      'code',
                    ],

                    toolbar:
                      'undo redo | accordion accordionremove | blocks fontfamily fontsize | bold italic underline strikethrough | align numlist bullist | link image | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | save print | pagebreak anchor codesample | ltr rtl',
                  }}
                  onEditorChange={handleEditorChange}
                />
              }
            />
          </Grid>
        </GeneralCard>
      </form>
      <Flex margin={'20px 0px 0px 40px'}>
        <Button colorScheme='red' size={'lg'} minWidth={'210px'} onClick={() => handleOnSubmit()} children={'Add'} />
      </Flex>
    </DefaultLayout>
  )
}
export default MailTemplateCreate
